import React from 'react'
import { Link } from 'react-router-dom';
import './FacultyDashboard.css'
const FacultySubjectCard = ({ course }) => {
    const sectionNames = course.section.name;
    return (
        <div className='col-md-4 col-lg-3 p-2 cardContainer'>
            <Link class="card  facultyCardView facultycontent facultyContent p-0" to={`/faculty/files/${course.subject._id}?year=${course.year}&sem=${course.sem}&branch=${course.section.branch._id}`} style={{ textDecoration: "none", color: "unset" }}>
                {/* <div class="card  facultyCardView facultycontent facultyContent p-0"> */}
                <h5 class="card-header headerDash" style={{ textAlign: "center" }}>
                    {course.section.degree.name}
                </h5>
                <div class="card-body">
                    <blockquote class="blockquote mb-0">
                        <div className='insideFacultyDash'>
                            <div className='insideParaDash'>Year</div>
                            <div>:{course.year}</div>
                        </div>
                        <div className='insideFacultyDash'>
                            <div className='insideParaDash'>semester</div>
                            <div>:{course.sem}</div>
                        </div>
                        <div className='insideFacultyDash'>
                            <div className='insideParaDash'>Branch</div>
                            <div>:{course.section.branch.name}</div>
                        </div>
                        <div className='insideFacultyDash'>
                            <div className='insideParaDash'>Sections</div>
                            <div>:{sectionNames}</div>
                        </div>
                        <div className='insideFacultyDash'>
                            <div className='insideParaDash'>Subject</div>
                            <div>:{course.subject.name}</div>
                        </div>

                    </blockquote>
                </div>
                {/* </div> */}
            </Link>
        </div>

    )
}

export default FacultySubjectCard